<template>
  <div></div>
</template>

<script>
export default {
  name: 'blank-div',
}
</script>



// WEBPACK FOOTER //
// src/components/BlankDiv.vue?2e44aa1f